export default function initGridNavigation(root = document) {
  const grids = root.querySelectorAll(".sz-icon-grid");

  grids.forEach((grid) => {
    const items = Array.from(grid.querySelectorAll("a"));

    if (!items.length) return;

    let currentIndex = 0;

    // roving tabindex
    items.forEach((el, i) => {
      el.tabIndex = i === 0 ? 0 : -1;
    });

    function focusItem(index) {
      if (index < 0 || index >= items.length) return;

      items[currentIndex].tabIndex = -1;
      currentIndex = index;
      items[currentIndex].tabIndex = 0;

      items[currentIndex].focus();

      items[currentIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }

    function getColumns() {
      const style = window.getComputedStyle(grid);
      const cols = style.gridTemplateColumns.split(" ").length;
      return cols || 4;
    }

    items.forEach((item, index) => {
      item.addEventListener("keydown", (e) => {
        const cols = getColumns();

        switch (e.key) {
          case "ArrowRight":
            e.preventDefault();
            focusItem((index + 1) % items.length);
            break;

          case "ArrowLeft":
            e.preventDefault();
            focusItem((index - 1 + items.length) % items.length);
            break;

          case "ArrowDown":
            e.preventDefault();
            if (index + cols < items.length) {
              focusItem(index + cols);
            }
            break;

          case "ArrowUp":
            e.preventDefault();
            if (index - cols >= 0) {
              focusItem(index - cols);
            }
            break;

          case "Home":
            e.preventDefault();
            focusItem(0);
            break;

          case "End":
            e.preventDefault();
            focusItem(items.length - 1);
            break;

          case " ":
            e.preventDefault();
            item.click();
            break;
        }
      });
    });
  });
}
